const urls = {
  dev: 'https://rest.siteplus.adult/geoip-service',
  prod: 'https://rest.edit.site/geoip-service',
};

/**
 * Get user location
 * @param {string} env
 * @returns {Promise<any>}
 */
const getLocation = async (env) => {
  const geoIpService = urls[env];

  if (!geoIpService) return;

  const geoDataResponse = await fetch(`${geoIpService}/geoip`);

  if (!geoDataResponse?.ok) return;

  return geoDataResponse.json();
};

export default getLocation;
